import logomark from 'assets/images/midnightswim/logomark.png';
import aquaristFullLogo from 'assets/images/aquarist/aquaristFullLogo.png';
import idleCafeLogo from 'assets/images/idleCafe/logomark.png';
import { Brand, size } from 'designs';

type BrandConfig = {
  /** Shown in the header bar. */
  headerLogo: string;
  /**
   * Wordmark set beside the header logo, for brands whose mark doesn't
   * already contain their name. The Aquarist logo is a wordmark in itself, so
   * it leaves this unset — never set text beside it.
   * Newlines are honoured, so the mark can stack.
   */
  headerWordmark?: string;
  /**
   * Wordmark casing. Defaults to uppercase; set false where the brand's face
   * draws accented capitals badly (PressStart2P's É sits at lowercase height).
   */
  headerWordmarkUppercase?: boolean;
  /** Wordmark type size. Defaults to `size.small`. */
  headerWordmarkSize?: string;
  /**
   * Header logo height. Defaults to 32px, but every brand sets whatever its
   * own mark needs — these are not meant to agree with each other.
   */
  headerLogoHeight?: string;
  /** Accessible name for the header logo. */
  name: string;
};

/**
 * One entry per brand the site dresses itself in. Midnight Swim is a brand
 * here like any other — not the default that the other overrides.
 */
export const BRANDS: Record<Brand, BrandConfig> = {
  midnightswim: {
    headerLogo: logomark,
    headerWordmark: 'Midnight\nSwim',
    name: 'Midnight Swim',
  },
  aquarist: {
    headerLogo: aquaristFullLogo,
    name: 'Aquarist',
  },
  // The art is the Moss & Moon cafe mark, so the app's own name is set as text
  // beside it — neither logo asset spells "Idle Cafe".
  idlecafe: {
    headerLogo: idleCafeLogo,
    headerWordmark: 'Idle Café',
    headerWordmarkUppercase: false,
    headerWordmarkSize: size.xxsmall,
    headerLogoHeight: '22px',
    name: 'Idle Café',
  },
};
